import { API_BASE, CREDENTIALS, POST_HEADERS } from 'constants/apis';
import { AnswerTypes } from 'types/survey';
import { getData, postData } from './index';
// Phase1で一時的にpreviewを対応する必要があるため、paramを取得
import 'core-js/features/url-search-params';

const params = new URLSearchParams(window.location.search);
const surveyUuid = document.location.pathname.split('/').pop();

export const fetchInitialSurveyStep = async () => {
  let url = `${API_BASE}/surveys/${surveyUuid}`;
  const preview = params.get('preview');
  if (preview) url += `?preview=${preview}`;
  const response = await getData(url);
  return response;
};

export const fetchSurveyStep = async (currentStepNumber: number) => {
  let url = `${API_BASE}/surveys/${surveyUuid}?step_number=${currentStepNumber}`;
  const preview = params.get('preview');
  if (preview) url += `&preview=${preview}`;
  const response = await getData(url);
  return response;
};

export const postAnswers = async (answers: AnswerTypes[], xCSRFToken: string) => {
  const url = `${API_BASE}/surveys/${surveyUuid}/answers`;
  const body =
    `survey_step_item_id=${encodeURIComponent(answers[0].surveyStepItemId)}` +
    `&value=${encodeURIComponent(answers[0].value)}`;
  const response = await postData(url, body, xCSRFToken);
  return response;
};

export const getSearchChoices = async (keyword: string) => {
  if (!keyword.trim()) return { payload: [] };

  let url = `${API_BASE}/surveys/${surveyUuid}/survey_departments`;
  if (keyword) url += `?keyword=${encodeURIComponent(keyword)}`;
  const preview = params.get('preview');
  if (preview) url += `&preview=${preview}`;
  const response = await getData(url);
  return response;
};

export const getDiveChoices = async (targetId: string | null) => {
  let url = `${API_BASE}/surveys/${surveyUuid}/survey_departments?parent_id=${
    targetId ? encodeURIComponent(targetId) : ''
  }`;
  const preview = params.get('preview');
  if (preview) url += `&preview=${preview}`;
  const response = await getData(url);
  return response;
};

export const postCompleteSurvey = async (xCSRFToken: string) => {
  const url = `${API_BASE}/surveys/${surveyUuid}/complete`;
  // completeのPOSTはresponseが無いため、statusを返す
  try {
    const res = await fetch(url, {
      credentials: CREDENTIALS,
      method: 'POST',
      headers: POST_HEADERS(xCSRFToken),
    });
    return { payload: { status: res.status } };
  } catch (error) {
    return { error };
  }
};
